var Vendd = (function (Vendd) {
    'use strict';

    Vendd.CallMeBack = (function (CallMeBack) {

        CallMeBack.Messages = (function (Messages) {

            Messages.Submit = function (email, firstname, lastname, phone, message, reCaptchaCode) {
                var data = {
                    email: email,
                    firstName: firstname,
                    lastName: lastname,
                    phone: phone,
                    message: message,
                    reCaptchaCode: reCaptchaCode
                };

            Vendd.MessageBus.VenddMessage.call(this, 'Vendd.CallMeBack.Messages.Submit', data);
        };
        Messages.Submit.className = 'Vendd.CallMeBack.Messages.Submit';

        Messages.SubmitSuccess = function (response) {
            Vendd.MessageBus.VenddMessage.call(this, 'Vendd.CallMeBack.Messages.SubmitSuccess', response);
        };
        Messages.SubmitSuccess.className = 'Vendd.CallMeBack.Messages.SubmitSuccess';

        Messages.SubmitFailure = function (response) {
            Vendd.MessageBus.VenddMessage.call(this, 'Vendd.CallMeBack.Messages.SubmitFailure', response);
        };
        Messages.SubmitFailure.className = 'Vendd.CallMeBack.Messages.SubmitFailure';

        return Messages;

    })(CallMeBack.Messages || {});

        return CallMeBack;

    })(Vendd.CallMeBack || {});

return Vendd;

})(Vendd || {});